import { useEffect } from 'react';
import {
  useTranslator,
  useAppContext,
  removeAuthCredentials,
  callNativeMobileApp,
} from '@front-activerse/common-components';

const SuccessView = () => {
  const { t } = useTranslator();

  const {
    images: { removeAccountSuccess },
  } = useAppContext();

  useEffect(() => {
    const id = setTimeout(() => {
      removeAuthCredentials();
      callNativeMobileApp({ action: 'forced_logout' });
      window.location.reload();
    }, 10000);
    return () => clearTimeout(id);
  }, []);

  return (
    <div className="white-box text-center">
      <img src={removeAccountSuccess} className="mb-l" alt="" />
      <p className="semi-bold mb-l">
        {t('deletingAccount.notification.accountDeletedConfirmation.title')}
      </p>
      <p className="mb-0">{t('deletingAccount.notification.accountDeletedConfirmation.content')}</p>
    </div>
  );
};

export default SuccessView;
